import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const installationManuals = [
  { id: '01', title: 'BIG BLOCK 1600® INSTALLATION MANUAL', code: '' },
];

export default function ResourcesPage() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const goToContact = () => {
    navigate('/');
    setTimeout(() => {
      const el = document.getElementById('contact');
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }, 300);
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-gray-900'}`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
            <div className="flex-shrink-0">
              <Link to="/">
                <img 
                  src="https://static.readdy.ai/image/82d44354838f3c049f6da9bd8c31e1b1/c02c3446a2b3e29ad54a764122882bc0.png" 
                  alt="NexBlocX" 
                  className="h-40"
                />
              </Link>
            </div>
            
            <div className="hidden md:flex items-center space-x-8">
              <Link 
                to="/"
                className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${isScrolled ? 'text-gray-700 hover:text-gray-900' : 'text-white hover:text-gray-200'}`}
              >
                Home
              </Link>
              <Link 
                to="/about"
                className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${isScrolled ? 'text-gray-700 hover:text-gray-900' : 'text-white hover:text-gray-200'}`}
              >
                About
              </Link>
              <Link 
                to="/#services"
                className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${isScrolled ? 'text-gray-700 hover:text-gray-900' : 'text-white hover:text-gray-200'}`}
              >
                Services
              </Link>
              <Link 
                to="/resources"
                className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${isScrolled ? 'text-amber-600' : 'text-amber-400'}`}
              >
                Resources
              </Link>
              <button 
                onClick={goToContact}
                className="bg-amber-500 text-gray-900 px-6 py-2.5 rounded-lg text-sm font-semibold hover:bg-amber-400 transition-colors cursor-pointer whitespace-nowrap inline-flex items-center"
              >
                Contact Us
              </button>
            </div>

            <button 
              className="md:hidden cursor-pointer"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            >
              <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl ${isScrolled ? 'text-gray-900' : 'text-white'}`}></i>
            </button>
          </div>
        </div>

        {mobileMenuOpen && (
          <div className="md:hidden bg-white border-t">
            <div className="px-4 py-4 space-y-3">
              <Link to="/" className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-50 rounded-lg cursor-pointer whitespace-nowrap">Home</Link>
              <Link to="/about" className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-50 rounded-lg cursor-pointer whitespace-nowrap">About</Link>
              <Link to="/#services" className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-50 rounded-lg cursor-pointer whitespace-nowrap">Services</Link>
              <Link to="/resources" className="block w-full text-left px-4 py-2 text-amber-600 bg-amber-50 rounded-lg cursor-pointer whitespace-nowrap">Resources</Link>
              <button 
                onClick={goToContact}
                className="block w-full text-left px-4 py-2 bg-amber-500 text-gray-900 hover:bg-amber-400 rounded-lg font-semibold cursor-pointer whitespace-nowrap"
              >
                Contact Us
              </button>
            </div>
          </div>
        )}
      </nav>

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-gray-900">
        <div className="absolute inset-0">
          <img 
            src="https://public.readdy.ai/ai/img_res/3c4a2f82740dbd7d309dc6158b3ac416.jpg"
            alt="Installation Documentation"
            className="w-full h-full object-cover opacity-30"
          />
        </div>
        <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">Installation &amp; Documentation</h1>
          <p className="text-xl text-gray-300">Insulated Concrete Installation Manuals</p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">

          {/* Installation Section */}
          <div>
            <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">Installation</h2>
            
            {installationManuals.map((manual) => (
              <div key={manual.id} className="bg-gray-50 rounded-lg p-6 mb-6 flex items-center justify-between hover:shadow-md transition-shadow">
                <div className="flex items-center">
                  <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-file-pdf-2-line text-2xl text-red-600"></i>
                  </div>
                  <div className="ml-4">
                    <span className="text-sm font-bold text-amber-600">{manual.id}</span>
                    <h3 className="text-lg font-bold text-gray-900">{manual.title}</h3>
                  </div>
                </div>
                <a 
                  href="https://www.dropbox.com/scl/fi/69l7xik0835eyylroqnk4/BigBlockInstallationManual-en.pdf?rlkey=ur2srwp01pelud0qexemy7azr&st=a8kiko57&dl=0" 
                  target="_blank"
                  rel="nofollow noreferrer"
                  className="flex items-center text-sm font-semibold text-gray-900 bg-amber-500 hover:bg-amber-400 px-5 py-2.5 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-download-2-line mr-2"></i>
                  Download PDF
                </a>
              </div>
            ))}
          </div>

          {/* Video Section */}
          <div className="mt-20">
            <h2 className="text-3xl font-bold text-gray-900 mb-4 text-center">Installation Videos</h2>
            <p className="text-lg text-gray-600 text-center mb-10 max-w-2xl mx-auto">
              Watch our step-by-step installation guides to learn proper ICF assembly techniques and best practices.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {Array.from({ length: 9 }, (_, i) => {
                const videoSources: Record<number, string> = {
                  0: 'https://www.dropbox.com/scl/fi/1o1ifixf2th9oq8m4qakk/blocdepart-esv2-89p-bg-12p.mp4?rlkey=5ry463xzknqrdwn6rtlwq83ds&st=nn7hqbqw&raw=1',
                  1: 'https://www.dropbox.com/scl/fi/ylxzok824mm8yb4nozu4o/starterbase.mp4?rlkey=yyabrksoo4qsu2lq2crntfaqm&st=4suhfbet&raw=1',
                  2: 'https://www.dropbox.com/scl/fi/xdseh4h2gsk1m8dgwj47u/rangeesubsequente-esv2-90p-bg-10p.mp4?rlkey=xbolndis8wiekzsf9sbk9qbhk&st=2jlhv7xq&raw=1',
                  3: 'https://www.dropbox.com/scl/fi/svz8id4espe9xk8h5srxc/tige-antisoulevement-esv2-90p-bg-10p.mp4?rlkey=4ef2nqckfq1yyrafp3kfumhlp&st=2p803k4b&raw=1',
                  4: 'https://www.dropbox.com/scl/fi/onl6nkzerx37mi8le5ilx/support-plancher-esv2-90p-bg-10p.mp4?rlkey=8nk6tcx4xn1lfc6d1s0icy5k1&st=7h09o0m3&raw=1',
                  5: 'https://www.dropbox.com/scl/fi/xe0guajgjax4qrpi1iflr/coinsguide-esv2-90p-bg-10p.mp4?rlkey=eut9wfnxpt9rquwgcbx64v97n&st=lx16aj5w&raw=1',
                  6: 'https://www.dropbox.com/scl/fi/s138sumf3sv2p3s1wa8d5/jointhook.mp4?rlkey=ivgj2i9jc9lm67n53rgcqmvo8&st=b6i47gnx&raw=1',
                  7: 'https://www.dropbox.com/scl/fi/hiewlpoq0x3wfpysdkt9i/cadresfenetre-esv2-90p-bg-10p.mp4?rlkey=5kunrx7qqpem6np9fh6a43xpp&st=m9aqs8ur&raw=1',
                  8: 'https://www.dropbox.com/scl/fi/4ubqpqwvjoyq4uwc85pkq/echaffaudage-esv2-90p-bg-10p.mp4?rlkey=3870sjpsg7c7xcalkz2j1l8gr&st=o8oz6gbj&raw=1',
                };
                const logoUrl = 'https://static.readdy.ai/image/82d44354838f3c049f6da9bd8c31e1b1/c02c3446a2b3e29ad54a764122882bc0.png';

                return (
                  <div key={i} className="bg-gray-50 rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow">
                    <div className="aspect-video w-full bg-gray-200 relative">
                      <video
                        controls
                        preload="metadata"
                        className="w-full h-full object-cover"
                        poster={logoUrl}
                      >
                        <source src={videoSources[i]} type="video/mp4" />
                        Your browser does not support the video tag.
                      </video>
                    </div>
                    <div className="p-4">
                      <h3 className="text-sm font-bold text-gray-900">Video {String(i + 1).padStart(2, '0')}</h3>
                      <p className="text-xs text-gray-500 mt-1">Installation Guide</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* CTA */}
          <div className="mt-20 bg-gray-900 rounded-2xl p-8 md:p-12 text-center">
            <h2 className="text-3xl font-bold text-white mb-6">Need Technical Assistance?</h2>
            <p className="text-lg text-gray-300 leading-relaxed mb-8">
              Our team is ready to help you with installation questions, technical specifications, and project-specific guidance.
            </p>
            <button 
              onClick={goToContact}
              className="inline-flex items-center bg-amber-500 text-gray-900 px-8 py-4 rounded-lg text-lg font-bold hover:bg-amber-400 transition-all transform hover:scale-105 cursor-pointer whitespace-nowrap"
            >
              Contact Our Team
              <i className="ri-arrow-right-line ml-2"></i>
            </button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="relative bg-gray-900 text-white py-16 overflow-hidden min-h-[500px]">
        <div className="absolute inset-0">
          <img 
            src="https://static.readdy.ai/image/82d44354838f3c049f6da9bd8c31e1b1/5f47c77c836e004333a2d82b946d5e21.jpeg" 
            alt="Footer Background" 
            className="w-full h-full object-cover object-center absolute inset-0"
          />
          <div className="absolute inset-0 bg-black/40"></div>
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12 items-start">
            <div className="pt-1">
              <img 
                src="https://public.readdy.ai/ai/img_res/3d38b249-c438-4355-9c41-27c4e7e91c1d.png" 
                alt="NexBlocX" 
                className="h-22"
              />
            </div>

            <div>
              <h4 className="text-lg font-bold mb-4">Company</h4>
              <ul className="space-y-2">
                <li><Link to="/about" className="text-gray-400 hover:text-white transition-colors cursor-pointer whitespace-nowrap">About</Link></li>
                <li><button onClick={goToContact} className="text-gray-400 hover:text-white transition-colors cursor-pointer whitespace-nowrap">Contact</button></li>
              </ul>
            </div>

            <div>
              <h4 className="text-lg font-bold mb-4">Why NexblocX</h4>
              <ul className="space-y-2">
                <li><Link to="/#features" className="text-gray-400 hover:text-white transition-colors cursor-pointer whitespace-nowrap">Our System</Link></li>
                <li><Link to="/#services" className="text-gray-400 hover:text-white transition-colors cursor-pointer whitespace-nowrap">Building with Steel</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-lg font-bold mb-4">Resources</h4>
              <ul className="space-y-2">
                <li><Link to="/resources" className="text-gray-400 hover:text-white transition-colors cursor-pointer whitespace-nowrap">Installation Docs</Link></li>
                <li><a href="#" className="text-gray-400 hover:text-white transition-colors">Project Gallery</a></li>
                <li><a href="#" className="text-gray-400 hover:text-white transition-colors">FAQ</a></li>
              </ul>
            </div>
          </div>

          <div className="border-t border-white/20 pt-8 mt-8">
            <div className="flex flex-col md:flex-row justify-between items-center">
              <div className="flex flex-wrap items-center justify-center md:justify-start gap-4 mb-4 md:mb-0 text-sm text-gray-400">
                <span>All rights reserved 2026 NexblocX Polycrete Systems</span>
                <span className="hidden md:inline">|</span>
                <Link to="/privacy" className="hover:text-white transition-colors">Privacy Policy</Link>
                <span>|</span>
                <Link to="/terms" className="hover:text-white transition-colors">Terms &amp; Conditions</Link>
                <span>|</span>
                <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">Powered by Readdy</a>
              </div>

              <div className="flex items-center space-x-4">
                <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" aria-label="LinkedIn"><i className="ri-linkedin-fill text-xl"></i></a>
                <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" aria-label="YouTube"><i className="ri-youtube-fill text-xl"></i></a>
                <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" aria-label="Facebook"><i className="ri-facebook-fill text-xl"></i></a>
                <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" aria-label="Instagram"><i className="ri-instagram-fill text-xl"></i></a>
                <a href="https://x.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" aria-label="X"><i className="ri-twitter-x-fill text-xl"></i></a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
